import { call, put, takeEvery } from "redux-saga/effects";
//actions
import {
  RemoveUserPermissionsSuccess,
  RemoveUserPermissionsFailure,
} from "../../actions/Settings/RemoveUserPermissions";
//constant
import { REMOVE_USER_PERMISSIONS } from "../../constants/Settings/RemoveUserPermissions";
//request type
import postRequest from "../../../util/APIHelperPost";
import { baseUrl } from "../../../util/APIBaseUrl";

export const fetchRemoveUserPermissionsRequest = async (actions) => {
  // eslint-disable-next-line no-return-await
  let body = JSON.stringify({
    email: actions.payload?.userProfileData?.email,
    firstName: actions.payload?.userProfileData?.name.split(" ")[0],
    lastName: actions.payload?.userProfileData?.name.split(" ")[1],
    country: actions.payload?.userProfileData?.country?.value,
    phoneNumber: actions.payload?.userProfileData?.phoneNumber,
  });

  return await postRequest(`${baseUrl}/${actions.payload.request}`, body)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

function* fetchRemoveUserPermissions(params) {
  try {
    let response = yield call(fetchRemoveUserPermissionsRequest, params);
    yield put(RemoveUserPermissionsSuccess(response));
  } catch (error) {
    console.error(error);
    yield put(RemoveUserPermissionsFailure(error));
  }
}

export default function* rootSaga() {
  yield takeEvery(REMOVE_USER_PERMISSIONS, fetchRemoveUserPermissions);
}
